import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'jhi-mobile-sort-block',
    templateUrl: './mobile-sort-block.component.html',
    styleUrls: ['./mobile-sort-block.component.scss']
})
export class MobileSortBlockComponent implements OnInit {
    @Output()
    sortKeyChanges: EventEmitter<string> = new EventEmitter();

    @Input()
    sortKey: string;

    constructor() {}

    ngOnInit() {}

    adjustSort(key: string) {
        this.sortKeyChanges.emit(key);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/mobile-sort-block/mobile-sort-block.component.ts